import React from 'react';

import { accountService, FormStatus, AccountForms } from '@lib/state';
import { useFormEvents, ChangePasswordForm, ChangePasswordFormFields, Section } from '@lib/common';

export const ChangePasswordComponent: React.FC = () => {
  const [{ status, error }, resetFormUI] = useFormEvents(AccountForms.ChangePassword);

  const submit = ({ newPassword, currentPassword }: ChangePasswordFormFields) => {
    accountService.changePassword(currentPassword, newPassword);
  };

  return (
    <Section title="Password" variant="contained">
      <ChangePasswordForm
        pending={status === FormStatus.Pending}
        success={status === FormStatus.Success}
        error={error}
        onSubmit={submit}
        onResetFeedback={resetFormUI}
        inputProps={{
          InputLabelProps: { shrink: true },
        }}
      />
    </Section>
  );
};
